import * as React from "react";
const SvgCheckbox = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", ...props }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, x: 2.5, y: 2.5, fill: "#fff", stroke: "currentColor", rx: 2 }));
export default SvgCheckbox;
